import React from 'react';
import atoms from '../../atoms';
import { WarrantyCardDetailProps } from './interface';
import { findConstantLabel, priceTagFormatter } from '../../../constants/utils';
import constant from '../../../constants/constant';
const { Button, CustomImages } = atoms

const WarrantyCardDetail:React.FC<WarrantyCardDetailProps> = ({ product, handleWarrantyClaim }) => (
  <div className="row">
    <div className="col-12 col-md-3 mt-4">
      <CustomImages src={product?.product?.images?.[0]} imageHeight='130px' />
    </div>

    <div className="col-12 col-md-9 mt-4">
      <div className='d-flex flex-wrap justify-content-between align-items-end'>
        <div>
          <h2 className='mb-0 fs-16 fw-600 dark-gray'>{product?.product?.brand?.brand_name}</h2>
          <div className="d-flex gap-3 align-items-center my-2">
            <h2 className='mb-0 fs-md-14 fs-12 fw-400 dark-gray'>
              Model {window.innerWidth < 768 ? 'No' : 'Number'} : <span className='fw-600'>{product?.product?.modal_number}</span>
            </h2>
            <h2 className='mb-0 fs-md-14 fs-12 fw-400 dark-gray'>
              Warranty: <span className='fw-600'>{findConstantLabel(constant?.PRODUCT_WARRANTY, product?.product?.warranty)}</span>
            </h2>
            <h2 className='mb-0 fs-md-14 fs-12 fw-400 dark-gray'>
              Polarized: <span className='fw-600'>{findConstantLabel(constant?.POLARIZED, product?.product?.isPolarised)}</span>
            </h2>
          </div>

          <div className="d-flex gap-3 align-items-center mb-2">
            <h2 className='mb-0 fs-md-14 fs-12 fw-400 dark-gray'>Color Code: <span className='fw-600'>{product?.product?.brand_color_code}</span></h2>
            <h2 className='mb-0 fs-md-14 fs-12 fw-400 dark-gray'>With Case: <span className='fw-600'>{product?.product?.product_with_case ? "Yes" : "No"}</span></h2>
            <h2 className='mb-0 fs-md-14 fs-12 fw-400 dark-gray'>Size/Power: <span className='fw-600'>{product?.product?.glass_size}MM</span></h2>
          </div>

          <p className='mb-0 fs-14 fw-500 dark-gray mt-3'>{product?.product?.description?.toUpperCase()}</p>
        </div>

        <div className='text-sm-start text-md-start text-lg-end mt-3 mt-md-0'>
          <p className='mb-0 fs-16 fw-600 dark-gray'>
            Paid :<span className='ps-2 fs-18 fw-600 dark-gray'>{priceTagFormatter(product?.product?.product_srp - product?.discount)}</span>
          </p>
        </div>
      </div>

      <Button className='d-md-none w-100 mt-3' onClick={() => handleWarrantyClaim(product?.id)}>Claim</Button>
    </div>
  </div>
);

export default WarrantyCardDetail;
